import { render } from "./chooseChain.vue?vue&type=template&id=25bbc0ee&scoped=true&lang=pug"
import script from "./chooseChain.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseChain.vue?vue&type=script&setup=true&lang=js"

import "./chooseChain.vue?vue&type=style&index=0&id=25bbc0ee&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bbc0ee"]])

export default __exports__